module.exports = require("./ewo.d.ts");